module.exports = Ember.HTMLBars.template((function() {
  return {
    isHTMLBars: true,
    revision: "Ember@1.11.1",
    blockParams: 0,
    cachedFragment: null,
    hasRendered: false,
    build: function build(dom) {
      var el0 = dom.createDocumentFragment();
      var el1 = dom.createElement("g");
      dom.setAttribute(el1,"fill","none");
      dom.setAttribute(el1,"fill-rule","evenodd");
      var el2 = dom.createElement("g");
      dom.setAttribute(el2,"transform","translate(1 1)");
      dom.setAttribute(el2,"stroke-width","2");
      var el3 = dom.createElement("circle");
      dom.setAttribute(el3,"stroke-opacity",".1");
      dom.setAttribute(el3,"cx","18");
      dom.setAttribute(el3,"cy","18");
      dom.setAttribute(el3,"r","18");
      dom.appendChild(el2, el3);
      var el3 = dom.createElement("path");
      dom.setAttribute(el3,"d","M36 18c0-9.94-8.06-18-18-18");
      var el4 = dom.createElement("animateTransform");
      dom.setAttribute(el4,"attributeName","transform");
      dom.setAttribute(el4,"type","rotate");
      dom.setAttribute(el4,"from","0 18 18");
      dom.setAttribute(el4,"to","360 18 18");
      dom.setAttribute(el4,"dur","0.5s");
      dom.setAttribute(el4,"repeatCount","indefinite");
      dom.appendChild(el3, el4);
      dom.appendChild(el2, el3);
      dom.appendChild(el1, el2);
      dom.appendChild(el0, el1);
      return el0;
    },
    render: function render(context, env, contextualElement) {
      var dom = env.dom;
      dom.detectNamespace(contextualElement);
      var fragment;
      if (env.useFragmentCache && dom.canClone) {
        if (this.cachedFragment === null) {
          fragment = this.build(dom);
          if (this.hasRendered) {
            this.cachedFragment = fragment;
          } else {
            this.hasRendered = true;
          }
        }
        if (this.cachedFragment) {
          fragment = dom.cloneNode(this.cachedFragment, true);
        }
      } else {
        fragment = this.build(dom);
      }
      return fragment;
    }
  };
}()));